const NAME = 'iavot-auth'
export default {
  read: function () {
    return window.localStorage.getItem(NAME)
  },
  write: function (token) {
    window.localStorage.setItem(NAME, token)
  },
  exists: function () {
    return !!window.localStorage.getItem(NAME)
  },
  clear: function () {
    window.localStorage.removeItem(NAME)
  }
}



// WEBPACK FOOTER //
// ./src/api/local-token.js